import { useState } from 'react';
import { Ring } from '@uiball/loaders';
import { createContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export function DataContainer({ children, actionType, actionTypes, forceLoading = false, style = {} }) {
    const isLoading = useSelector((state) => forceLoading || (actionType ? state.loading[actionType] : actionTypes.some((type) => state.loading[type])));

    return (
        <div className='column' style={{ ...style, position: 'relative' }}>
            {
                <div style={{ ...style, opacity: (isLoading ? 0.4 : 1) }}>
                    {children}
                </div>
            }
            {
                isLoading && <div className='column center-main center-cross' style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }}><Ring color='#a44' speed={2} size={60} lineWeight={3} /></div>
            }
        </div>
    );
}